import * as React from 'react'
import type { RouteObject } from 'react-router'

const MyOrders = React.lazy(() => import('../views/MyOrders/MyOrders'))
const Products = React.lazy(() => import('../views/Products/Products'))
const DeliverySummary = React.lazy(
    () => import('../views/DeliverySummary/DeliverySummary'),
)

export const OrderRouter: RouteObject[] = [
    {
        path: '/my-orders',
        element: <MyOrders />,
    },
    {
        path: '/products',
        element: <Products />,
    },
    {
        path: '/delivery-summary',
        element: <DeliverySummary />,
    },
]
